import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const STATUS_META = {
  approved: { color: 'success', icon: CheckCircleRoundedIcon, label: 'Approved' },
  fully_approved: { color: 'success', icon: CheckCircleRoundedIcon, label: 'Approved' },
  rejected: { color: 'error', icon: CancelRoundedIcon, label: 'Rejected' },
  cancelled: { color: 'warning', icon: DoDisturbOnRoundedIcon, label: 'Cancelled' },
  canceled: { color: 'warning', icon: DoDisturbOnRoundedIcon, label: 'Cancelled' },
  pending: { color: 'warning', icon: HourglassTopRoundedIcon, label: 'Pending' },
  revision: { color: 'info', icon: AutorenewRoundedIcon, label: 'Revision' },
  revision_requested: { color: 'info', icon: AutorenewRoundedIcon, label: 'Revision' },
  scheduled: { color: 'info', icon: HourglassTopRoundedIcon, label: 'Scheduled' },
  sending: { color: 'warning', icon: AutorenewRoundedIcon, label: 'Sending' },
  sent: { color: 'success', icon: CheckCircleRoundedIcon, label: 'Sent' },
  failed: { color: 'error', icon: CancelRoundedIcon, label: 'Failed' },
  queued: { color: 'info', icon: HourglassTopRoundedIcon, label: 'Queued' },
  skipped: { color: 'default', icon: DoDisturbOnRoundedIcon, label: 'Skipped' },
  in_progress: { color: 'info', icon: AutorenewRoundedIcon, label: 'In Progress' },
  draft: { color: 'default', icon: InfoRoundedIcon, label: 'Draft' },
  submitted: { color: 'info', icon: AutorenewRoundedIcon, label: 'Submitted' },
  active: { color: 'success', icon: CheckCircleRoundedIcon, label: 'Active' },
  inactive: { color: 'default', icon: DoDisturbOnRoundedIcon, label: 'Inactive' },
};

const toLabel = (status) =>
  String(status || '')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (m) => m.toUpperCase())
    .trim();

export default function StatusBadge({
  status,
  variant = 'soft',
  size = 'small',
  icon = true,
  sx,
  label,
}) {
  const key = String(status || '').trim().toLowerCase();
  const meta = STATUS_META[key] || {
    color: 'default',
    icon: InfoRoundedIcon,
    label: label || toLabel(status) || 'Unknown',
  };

  const resolvedVariant = variant === 'soft' ? 'filled' : variant;
  const IconComp = meta.icon;

  return (
    <Chip
      size={size}
      color={meta.color}
      variant={resolvedVariant}
      label={label || meta.label}
      icon={icon ? <IconComp sx={{ fontSize: 15 }} /> : undefined}
      sx={[
        variant === 'soft'
          ? {
              '&.MuiChip-filled': {
                border: '1px solid',
                borderColor: 'divider',
              },
            }
          : null,
        sx,
      ]}
    />
  );
}
